<template>
  <a-modal
    v-model="visible"
    width="60%"
    :title="$t('租赁单_申请减少箱量')"
    :okText="$t('confirm')"
    :cancelText="$t('cancel')"
    destroyOnClose
    @ok="confirm"
  >
    <a-form-model class="dol-edit-form" :model="editForm" :rules="editRule" ref="editForm">
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('amountOfDiscardedBoxes')">
            {{ maxApplyNumber }}
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('operationType')" prop="CHANGE_TYPE">
            <a-radio-group v-model="editForm.CHANGE_TYPE">
              <a-radio :value="0">
                {{ $t('通用_减少') }}
              </a-radio>
<!--              <a-radio v-auth="'ORDER_ADD_QUANTITY'" :value="1">-->
<!--                {{ $t('addTo') }}-->
<!--              </a-radio>-->
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('通用_箱量')" prop="CHANGE_QTY">
            <a-input-number v-model.trim="editForm.CHANGE_QTY"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('通用_备注')" prop="MEMO">
            <a-textarea v-model="editForm.MEMO" :placeholder="$t('提示_请填写备注')" :auto-size="{ minRows: 3 }" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import CitySelect from '@/components/contcircle/form/city-select.vue';

export default {
  name: 'reduce-number-modal',
  components: { CitySelect },
  props: {
    sheetData: {type: Object},
  },
  data () {
    return {
      visible: false,
      applyXCFlow: null,
      editForm: {},
    };
  },
  computed: {
    editRule(){
      return {
        CHANGE_QTY: [{required: true, message: this.$t('pleaseFillInTheNumberOfBoxes'), trigger: ['blur', 'change']}],
      }
    },
    maxApplyNumber(){
      if(!(this.applyXCFlow && this.sheetData.OT_XC_MASTER)) return 0;
      let total = this.sheetData.OT_XC_MASTER[0].SHEET_QTY;
      this.sheetData.OT_BOX_XE_DETAIL.forEach(item => total -= item.REAL_QTY);
      return total;
    },
  },
  methods: {
    open(record){
      this.applyXCFlow = record || (this.sheetData && this.sheetData.OT_XC_DETAIL[0]);
      this.editForm = {
        CHANGE_TYPE: 0,
      };
      this.visible = true;
    },
    confirm(){
      return this.$refs.editForm.validate(result => {
        if(!result){
          return true;
        }

        const submitData = [{ "XC_FLOW_ID": this.applyXCFlow.FLOW_ID, ...this.editForm }];
        return this.$h5Api({
          type: '4092',
          data: submitData,
        }).then((resp) => {
          this.$message.success(this.$t('submitSuccess'));
          this.visible = false;
          this.$emit('reload');
        });
      })

    }
  }
};
</script>

<style lang="scss">

</style>
